"use client";

import { useRouter } from "next/navigation";
import { ArrowLeft } from "lucide-react";

export function BackButton() {
  const router = useRouter();

  const handleBack = () => {
    // Check if we have history to go back to
    if (window.history.length > 2) {
      router.back();
    } else {
      // If no history, just go to blog index
      router.push("/blog/page/1");
    }
  };

  return (
    <button className="font-semibold block mt-12" onClick={handleBack}>
      <ArrowLeft className="inline mr-0.5" size={16} /> Back to Tips & Tricks
    </button>
  );
}
